<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <b-container>
      <b-row align-v="center">
        <b-col cols="auto">
          <v-btn class="btn-return" @click="$router.go(-1)">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i>
            VOLTAR
          </v-btn>
        </b-col>
        <b-col>
          <h1 class="title-pages">CONFIGURAÇÃO DE HOME CARE / FAMÍLIA</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card title="">
            <div class="row">
              <div class="col-md-12">
                <label>ATIVAR CONFIGURAÇÃO?</label>
                <select v-model="allow_home_care" class="form-control">
                  <option value="SIM">SIM</option>
                  <option value="NAO">NÃO</option>
                </select>
              </div>
              <div v-show="allow_home_care == 'SIM'" class="col-md-12">
                <p class="worksansr">
                  A Configuração de HOME CARE está <strong>ATIVA</strong>!
                </p>
                <p class="worksansr">
                  Para definir quais residentes o usuário tem acesso:
                </p>
                <p class="worksansr">
                  Acesse menu Usuários <code class="m-1">→</code> Usuários
                  <code class="m-1">→</code> Clique na linha do Usuário
                  <code class="m-1">→</code> Clique na aba
                  <strong>HOME CARE / FAMÍLIA</strong>
                  <code class="m-1">→</code> Em
                  <strong>ATIVAR CONFIGURAÇÃO NO RESPECTIVO USUÁRIO</strong>
                  <code class="m-1">→</code> Selecione <strong>SIM</strong>
                  <code class="m-1">→</code> Em seguida selecione os residentes
                  que o usuário vai ter permissão para acessar!
                </p>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <errors-messages :errors="errors" />
      <b-row align-h="end">
        <b-col cols="auto">
          <confirmation-dialog
            message-title="CONFIRMAÇÃO"
            message-body="TEM CERTEZA QUE DESEJA SALVAR?"
            open-class="btn-save"
            open-text="SALVAR"
            openLeftIcon="fa-check"
            @yes="save"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog";

import api from "../services/api";

import toast from "../lib/ToastNotification";

export default {
  name: "ConfigHomeCare",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    ConfirmationDialog,
  },

  data() {
    return {
      errors: [],
      allow_home_care: "NAO",
      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    async retrieve() {
      await this.get();
    },

    async get() {
      this.loading = true;

      const response = await api.get("/rest-home/settings/config-home-care");

      const { error, errors, allow_home_care } = response.data;

      if (error) {
        this.errors = errors;
      } else {
        this.errors = [];
        this.allow_home_care = allow_home_care == 1 ? "SIM" : "NAO";
      }
    },

    async save() {
      try {
        this.loading = true;

        let { allow_home_care } = this;

        if (allow_home_care == "SIM") {
          allow_home_care = 1;
        } else {
          allow_home_care = null;
        }

        const data = { allow_home_care };

        const response = await api.patch(
          "/rest-home/settings/config-home-care",
          data
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message);
          this.retrieve();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
